
  import { defineComponent } from 'vue';  

  export default defineComponent({
    name: 'HomeView',
    async beforeCreate() {
        document.body.className = 'home';
    }
  });
